import {
  createContext,
  useContext,
  useState,
  ReactNode,
  FC,
  useEffect,
} from "react";
import { getUserProfile, logout } from "../repositories/PredsenseRepository";
import { localStorageGet } from "../utils/LocalStorageHelper";
import { IUserInfo } from "../types/User";
import { IBooleanObject } from "../types/Base";
import { Loader } from "../components/Loader";
import { Login } from "../pages/Login";
import { convertArrayToBooleanObject } from "../utils/ArrayUtuls";

interface UserContextType {
  user: IUserInfo | null;
  reloadUser: (callback?: () => void) => void;
  privileges: IBooleanObject;
}

const UserContext = createContext<UserContextType>({
  user: null,
  reloadUser: () => {},
  privileges: {},
});

export const UserProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<IUserInfo | null>(null);
  const [privileges, setPrivileges] = useState<IBooleanObject>({});
  const [isLoading, setIsLoading] = useState(true);

  const token = localStorageGet("token");

  const reloadUser = (callback?: () => void) =>
    getUserProfile()
      .then((user) => {
        setUser(user);
        setPrivileges(convertArrayToBooleanObject(user.privileges));
        callback?.();
      })
      .catch(() => {});

  useEffect(() => {
    if (token) {
      setIsLoading(true);
      getUserProfile()
        .then((user) => {
          if (user?.uuid) {
            setUser(user);
            setPrivileges(convertArrayToBooleanObject(user.privileges));
          } else {
            logout();
          }
        })
        .catch(() => {})
        .finally(() => setIsLoading(false));
    } else setIsLoading(false);
  }, [token]);

  return (
    <UserContext.Provider value={{ user, reloadUser, privileges }}>
      {isLoading ? <Loader isLoading /> : !token ? <Login /> : children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
